<form #projectForm="ngForm">
  <div class="row">
    <div class="col-md-6 pr-1">
      <div class="form-group">
        <label>Project: {{currentProject?.id}}</label>
        <input type="text" [disabled]="currentProject.apiKey" name="projectName" required [(ngModel)]="currentProject.projectShortName" class="form-control" placeholder="Input Project Short Name">
      </div>
    </div>
    <div class="col-md-6 pl-1">
      <div class="form-group">
        <label>API Key</label>
        <input type="text" [(ngModel)]="currentProject.apiKey" name="apikey" class="form-control" disabled="" placeholder="" value="">
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!currentProject.apiKey">
    <div class="update ml-auto mr-auto">
      <button *ngIf="!currentProject.apikey" [disabled]="!projectForm.valid"  type="submit" (click)="onSave()" class="btn btn-primary btn-round">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span> Save</span>
      </button>
    </div>
  </div>
</form>
